import { CellContext } from "@tanstack/react-table";
import { WorkspaceAssignmentsList } from "../../WorkspaceAssignmentsList";
import { WorkspaceDetailsRow } from "./NameCell";

export function TeamCell({
    row,
}: Readonly<CellContext<WorkspaceDetailsRow, any>>) {
    return <WorkspaceAssignmentsList assignments={row.original.assignments} />;
}
